module.exports = {
    CLASS_ANCHOR: '.js-accorion-anchor',
    CLASS_EXPANDED: 'expanded',
    CLASS_TOGGLE: '.toggle',
    CLASS_INNER: '.js-accordion-inner',
    CLASS_PARENT: '.js-accordion-parent'
};